import * as React from 'react';

import { Helmet } from 'react-helmet-async';
import { useLoaderData } from 'react-router-dom';

import type { PageBuilderCategory } from 'types';

import { PageBuilderFooterHeader, PageBuilderFooterInfo } from './components';

type PageBuilderFooterLoaderData = {
  bestSellerCategories: PageBuilderCategory[];
};

export default function PageBuilderFooter() {
  const data = useLoaderData() as PageBuilderFooterLoaderData | undefined;

  const { bestSellerCategories = [] } = data ?? {};

  return (
    <React.Fragment>
      <Helmet>
        <title>فوتر | کاشی لند</title>
      </Helmet>
      <PageBuilderFooterHeader />
      <div className='rounded bg-white'>
        <PageBuilderFooterInfo bestSellerCategories={bestSellerCategories} />
      </div>
    </React.Fragment>
  );
}
